// The API has no mascots — map the festival's borghi to an emoji each.
// Shared so the leaderboard race and any reused token look identical.
export const MASCOTS: Record<string, string> = {
  Sornico: '🐿️',
  Sottocastello: '🐎',
  Salt: '🦐',
  Sottomonte: '🐰',
  Villa: '🐼',
};

export const FALLBACK_EMOJI = '🏁';
